import React from 'react'

export const ShowHideIcon = ({isVisible}: {isVisible: boolean}) => {    
    return isVisible ?
    <i className="bi bi-eye-slash"></i> :
    <i className="bi bi-eye"></i>
}
